const dev = {
  environment: 'dev',
  production: false,
  // API_URL: 'https://server.monitorando.me/api',
  //  API_URL: 'https://server.staging.monitorando.me/api',
  API_URL: 'http://localhost:8082/api/',
  // socketURL: 'wss://server.monitorando.me/api/socket',
  //  socketURL: 'wss://server.staging.monitorando.me/api/socket',
  socketURL: 'ws://localhost:8082/api/socket',
  traceLimit: 5,
  eventLimit: 200,
  PATH: {
    device_icons: `${process.env.PUBLIC_URL}/images/device_icons`,
  },
  azulPay: {
    url: 'https://sandboxazulpay.pagtech.me/api/v1',
    base: 'https://sandboxazulpay.pagtech.me',
  },
};

const prod = {
  environment: window.location.hostname,
  production: true,
  OSM_AND_BASE_URL: 'https://server.monitorando.me/rota',
  BASE_URL: 'https://server.monitorando.me',
  get API_URL() {
    return `${this.BASE_URL}/api/`;
  },
  socketURL: 'wss://server.monitorando.me/api/socket',
  azulPay: {
    url: 'https://www.azulpay.online/api/v1',
    base: 'https://www.azulpay.online',
  },
};

const config = process.env.REACT_APP_ENV === 'prod' ? {...dev, ...prod} : dev;

export default {...config};
